export var OffsetType;
(function (OffsetType) {
    OffsetType["VERTEX"] = "VERTEX";
    OffsetType["INDEX"] = "INDEX";
    OffsetType["STRING"] = "STRING";
    OffsetType["KEY"] = "KEY";
})(OffsetType || (OffsetType = {}));
//# sourceMappingURL=offsetType.js.map